/** Orthographic globe: Natural Earth 110m land points, shared projection for editor pins. */
import points from "./land-points.json";

/** Generated offline on a 2.4° grid; see assets/demo/MEDIA-PROMPTS.md. */
export function landDots(): Array<[number, number]> {
  return points as Array<[number, number]>;
}

export interface Projected {
  /** -1..1 on the disc, y down. */
  x: number;
  y: number;
  /** z > 0 = front hemisphere; also the depth for fading toward the rim. */
  z: number;
}

/** Orthographic projection with the globe turned so `centerLng`/`tiltLat` faces the viewer. */
export function project(lng: number, lat: number, centerLng: number, tiltLat = 18): Projected {
  const rad = Math.PI / 180;
  const l = (lng - centerLng) * rad;
  const p = lat * rad;
  const t = tiltLat * rad;
  const x = Math.cos(p) * Math.sin(l);
  const y0 = Math.sin(p);
  const z0 = Math.cos(p) * Math.cos(l);
  // Tilt around the x axis so the centre latitude faces us.
  const y = y0 * Math.cos(t) - z0 * Math.sin(t);
  const z = y0 * Math.sin(t) + z0 * Math.cos(t);
  return { x, y: -y, z };
}
